export default __webpack_public_path__ + "static/media/TTNorms-Bold.9a14176c.woff2";